// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/compras/services/budgetService.ts
//  Serviço de CRUD e comparativo de orçamento de compras (Fase 3 · Iter 3.4).
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  BudgetVsRealizadoResponse,
  CompraBudget,
  SalvarCompraBudgetRequest,
} from '../types';

const BASE = '/api/compras/budget';

export const budgetService = {
  listar: (ano?: number) =>
    apiClient
      .get<CompraBudget[]>(BASE, { params: ano ? { ano } : undefined })
      .then((r) => r.data),

  criar: (req: SalvarCompraBudgetRequest) =>
    apiClient.post<CompraBudget>(BASE, req).then((r) => r.data),

  atualizar: (id: number, req: SalvarCompraBudgetRequest) =>
    apiClient.put<CompraBudget>(`${BASE}/${id}`, req).then((r) => r.data),

  excluir: (id: number) =>
    apiClient.delete<void>(`${BASE}/${id}`).then((r) => r.data),

  comparativo: (ano: number, mesInicio?: number, mesFim?: number) =>
    apiClient
      .get<BudgetVsRealizadoResponse>(`${BASE}/comparativo`, {
        params: { ano, ...(mesInicio ? { mesInicio } : {}), ...(mesFim ? { mesFim } : {}) },
      })
      .then((r) => r.data),
};
